// reCAPTCHA container/verifier lifecycle helpers, extracted from CRMAuthContext so the teardown
// contract is unit-testable (jsdom). The core rule: NEVER wipe the visible container's innerHTML while
// the Enterprise reCAPTCHA script still owns/renders it — doing so caused
// "Cannot read properties of null (reading 'style')" in recaptcha__en.js after a successful OTP.
// The authoritative teardown is verifier.clear(); hiding is CSS-only.

export const VISIBLE_ID = 'crm-recaptcha-visible';

// Hide the visible fallback container. CSS only — no innerHTML removal.
export function hideVisibleRecaptcha(doc) {
  try {
    const v = doc && doc.getElementById(VISIBLE_ID);
    if (v && v.style) v.style.display = 'none';
    return true;
  } catch (e) {
    return false;
  }
}

// Idempotent verifier teardown: call clear() if present, then null the global handle.
export function teardownVerifier(win) {
  try {
    const v = win && win.__crmRecaptchaVerifier;
    if (v && typeof v.clear === 'function') v.clear();
  } catch (e) {
    /* ignore — teardown must never throw */
  }
  if (win) win.__crmRecaptchaVerifier = null;
}

export default { VISIBLE_ID, hideVisibleRecaptcha, teardownVerifier };
